.connection {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	outline: none;
}

.label {
	pointer-events: all;
	margin-bottom: 25px;
	color: var(--ds-text, var(--adg3-color-N900));
	padding: 15px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	cursor: pointer;
}

.label > div {
	padding: 0;
}
